const React = require('react');
const StockExchangeIndexVariation = require('./stockExchangeIndexVariation');

class StockExchangeIndexVariationBracket extends StockExchangeIndexVariation {

    showVariation(plusOrLessPts, variationPts, plusOrLessPercentage, variationPerc) {
        return (
            <span>
                {plusOrLessPts}{variationPts} ({plusOrLessPercentage}{variationPerc}%)
            </span>
        );
    }
}

module.exports = StockExchangeIndexVariationBracket;
